import styled from 'styled-components';

import CloseIcon from '../../icons/CloseIcon';

export const HamburgerBar = styled.span`
  display: block;
  width: 1.9rem;
  height: 2px;
  box-shadow: 0 1.5px 0 var(--color-black);

  &:not(:last-child) {
    margin-bottom: 0.4rem;
  }
`;

export const StyledCloseIcon = styled(CloseIcon)`
  color: var(--color-black);
`;

export const LoginWrapper = styled.div`
  display: none;
  @media (${({ theme }) => theme.respondTo.tablet}) {
    display: contents;
  }
`;

export const HamburgerMenu = styled.div`
  width: 5.2rem;
  height: 5.2rem;
  background: var(--color-bg);
  border-radius: var(--border-radius-default) 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 2rem;

  ${({ navIsOpen }) =>
    navIsOpen &&
    `
    background: var(--color-primary);

    ${StyledCloseIcon} {
      color: var(--color-white);
    }
  `}
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  z-index: 3;
`;
